import moment from 'moment';
import {convertInquiryTypeToText, convertMailTypeToText} from "../../../utils/helpler-utils";

export default {
    SET_MAIL_BOX(state, data) {
        state.mailBox = data
    },
    SET_MAIL_SEND_BULK(state, data) {
        state.listMailSendBulk = data
    },
    SET_INDEX_GROUP_OPEN(state, data) {
        if(data.clear_index){
            state.indexGroupOpen = [];
        }else if(data.delete){
            state.indexGroupOpen.splice(state.indexGroupOpen.indexOf(data.index), 1);
        }else{
            if(state.indexGroupOpen.indexOf(data.index) == -1){
                state.indexGroupOpen.push(data.index);
            }
        }
    },    
    
    SET_CURRENT_MAIL_BOX_SELECT(state, mailbox) {
        state.currentMailBoxSelect = mailbox
    },
    SET_LIST_MAIL_RECEIVED(state, listMailReceive) {
        let result = [];
        if (listMailReceive && listMailReceive.length > 0) {
            result = listMailReceive.map(element => {
                // if (element.receive_datetime) {
                //     element.receive_datetime = moment(element.receive_datetime).format('YYYY-MM-DD')
                // }
                if (element.response_limit) {
                    element.response_limit =  moment(element.response_limit).format('YYYY-MM-DD')  
                }
                if (typeof element.state_flg !== 'undefined') {
                    if (element.state_flg === -1) {
                        element.state_flg_text = '削除'
                    } else if (element.state_flg === 0) {
                        element.state_flg_text = '未対応'
                    } else if (element.state_flg === 1) {
                        element.state_flg_text = '対応中'
                    } else if (element.state_flg === 2) {
                        element.state_flg_text = '返信済（回答待ち）'
                    } else if (element.state_flg === 3) {
                        element.state_flg_text = '返信済'
                    } else if (element.state_flg === 4) {
                        element.state_flg_text = '完了'
                    } else {
                        element.state_flg_text = ''
                    }
                }
                element.type_text = convertMailTypeToText(element.type, element.kinds_name, element.kinds_state)
                if (element.full_name === null) {
                    element.full_name = '未設定'
                }
                element.inquiry_type_text = convertInquiryTypeToText(element.inquiry_type)
                return element
            })
        }
        state.listMailReceive = result
    },
    SET_THREAD_MAIL_DETAIL(state, payload){
        state.mailThreadView = payload
    },
    SET_SEARCH_FILTER(state, payload){
        state.searchFilter = payload
    },
    CLEAR_SERACH_FILTER(state){
        state.searchFilter = null
    },
    SET_MODE(state) {
        state.mode = !state.mode
    },
    SET_SELECTED_RECEIVE_MAIL(state, payload) {
      state.selectedReceiveMail = payload;
    },
    SET_LIST_INCLUDE_SUBFOLER(state, payload) {
        state.listIncludeSubFolder = payload;
    },
    SET_MAIL_DETAIL(state , payload) {
        state.mailDetail = payload;
    },
    CLEAR_MAIL_DETAIL(state , payload) {
        state.mailDetail = null;
    },

}